// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609041434/js/" + chunkId + "." + {"44":"376c1af7","225":"d62c0c4c","481":"e6db1324","486":"83124b12","770":"04a11db3"}[chunkId] + ".0.05957901377938746.chunk.js";
};